import NextLink from 'next/link';
import { Container, Typography, Link } from '@mui/material';
import { legalTextSea50K } from 'lib/constants/legalTexts';

export const SeaLegalText = ({ showLegalText }: { showLegalText: boolean }) => {
  if (!showLegalText) return null;

  return (
    <Container maxWidth="lg" sx={{ marginTop: '16px' }}>
      <Typography variant="body2" color="textSecondary">
        <b>Sparen Sie über 35% mit Finanzcheck:</b> Vgl. der eff.
        Jahreszinssätze neuer (lt. Bundesbank) mit den über Finanzcheck
        vermittelten Krediten 2020.{' '}
        <Link
          href="/kreditvergleich/"
          component={NextLink}
          color="textSecondary"
          prefetch={false}
          sx={{ textDecoration: 'underline' }}
        >
          Mehr&nbsp;Infos
        </Link>
      </Typography>
      <Typography variant="body2" color="textSecondary" mt={1}>
        {legalTextSea50K}
      </Typography>
    </Container>
  );
};
